import { DictionaryEvidence, TableColumn } from '@eas/common-web';
import { WorkOrderState } from '@models';

export function useColumns(): TableColumn<WorkOrderState>[] {
  const dictionaryColumns =
    DictionaryEvidence.useDictionaryColumns<WorkOrderState>();

  return [dictionaryColumns.columnName, dictionaryColumns.columnCode];
}
